/*
 * Module for handling the list of campaigns in the campaigns page
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/selectableList/selectableListModule",
], function (Marionette, Messenger, SelectableListModule) {
  return SelectableListModule.extend({
    /*
     * Overwrite default function to allow a save check before selections
     */
    selectItem: function (clickedModel) {
      //validate the model before switching (if there is a selected model)
      if (!this.selectedModel || this.selectedModel.isValid()) {
        // save the current model if dirty
        this._saveCampaign(this.selectedModel).then(() => this._selectItem(clickedModel));
      }
    },
    _selectItem: function (clickedModel) {
      if (this.selectedModel !== null) {
        this._markAsUnselected(); //unselect current item
        Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
      }
      this.selectedModel = clickedModel;
      if (this.selectedModel !== null) {
        this._markAsSelected();
        //if the model is removed, then just set this.selectedModel to null
        this.selectedModel.once("remove", () => {
          this.selectedModel = null;
        });
        Messenger.vent.trigger("campaign:selected", clickedModel);
      }
    },
    _saveCampaign: async function (model) {
      if (model && model.dirty) {
        try {
          await this.selectedModel.saveModelPromise();
        } catch (error) {
          console.error("Error saving campaign", error);
        }
      }
    },
  });
});
